/* =========================================================================
   Coffeetine — landing de tráfego frio. Carregado só no template
   page.landing-coffeetine.

   O zero.js continua dono de tudo que é da loja: adicionar ao carrinho
   (/cart/add.js), abrir a gaveta, disparar o evento do pixel, acordeões e
   autoplay de vídeo ao entrar na tela. Este arquivo cuida apenas do que é
   exclusivo da página:

     1. o rótulo do botão muda com o kit escolhido;
     2. a barra fixa do celular acompanha a escolha e aparece na hora certa.

   Nada aqui toca em URL, query string, UTM, gclid ou histórico.
   ========================================================================= */
(function () {
  'use strict';

  var oferta = document.querySelector('[data-lp-offer]');
  var barra = document.querySelector('[data-lp-sticky]');

  function texto(el, valor) {
    if (el && valor != null && el.textContent !== valor) el.textContent = valor;
  }

  /* ------------------------------------------------------------ escolha  */

  function aplicar(card) {
    if (!card || !oferta) return;

    // Estado dos cartões. O zero.js já faz isso pelo [data-routine-card];
    // repetir aqui é de graça e mantém a página inteira em pé mesmo se o
    // arquivo compartilhado falhar em carregar.
    var cards = oferta.querySelectorAll('[data-routine-card]');
    for (var i = 0; i < cards.length; i++) {
      var atual = cards[i] === card;
      cards[i].classList.toggle('active', atual);
      var radio = cards[i].querySelector('input[type="radio"]');
      if (radio) radio.checked = atual;
    }

    var escolhido = oferta.querySelector('[data-selected-variant]');
    if (escolhido && card.dataset.variantId) escolhido.value = card.dataset.variantId;
    // a mesma caixa em quantidade 1, 2 ou 3
    var qtd = oferta.querySelector('[data-selected-quantity]');
    if (qtd && card.dataset.quantity) qtd.value = card.dataset.quantity;

    // "EXPERIMENTAR 30 DIAS · R$ 179" / "COMPRAR 2 CAIXAS · R$ 329"
    var botao = oferta.querySelector('[data-product-buy]');
    if (botao && !botao.dataset.loading && card.dataset.lpCta) {
      texto(botao, card.dataset.lpCta + ' · ' + (card.dataset.lpPrice || ''));
    }

    texto(oferta.querySelector('[data-lp-chosen]'), card.dataset.lpTitle || '');

    if (barra) {
      texto(barra.querySelector('[data-lp-sticky-doses]'), card.dataset.lpDoses || '');
      texto(barra.querySelector('[data-lp-sticky-price]'), card.dataset.lpPrice || '');
      var add = barra.querySelector('[data-sticky-add]');
      if (add && card.dataset.variantId) {
        add.dataset.variantId = card.dataset.variantId;
        add.dataset.quantity = card.dataset.quantity || '1';
      }
    }
  }

  if (oferta) {
    oferta.addEventListener('click', function (evento) {
      var card = evento.target.closest('[data-routine-card]');
      if (card && !card.classList.contains('lp-kit--out')) aplicar(card);
    });

    // teclado: o cartão é um <label> com rádio dentro, então a troca também
    // chega por setas sem passar por clique.
    oferta.addEventListener('change', function (evento) {
      if (evento.target.type !== 'radio') return;
      var card = evento.target.closest('[data-routine-card]');
      if (card) aplicar(card);
    });
  }

  /* ------------------------------------------------- trecho do vídeo    */

  // O vídeo do preparo é mais longo do que a mensagem: no fim aparece um
  // canudo mexendo, que numa página cuja tese é "um sachê e pronto" sugere
  // que faz falta algum utensílio. Em vez de esperar um arquivo novo, a
  // seção roda só o trecho que mostra água, leite e o café pronto.
  function recortarVideo() {
    var quadro = document.querySelector('[data-lp-clip]');
    if (!quadro) return;
    var video = quadro.querySelector('video');
    if (!video) return;

    var inicio = parseFloat(quadro.getAttribute('data-lp-clip-start')) || 0;
    var fim = parseFloat(quadro.getAttribute('data-lp-clip-end')) || 0;
    if (!(fim > inicio)) return;

    function voltar() {
      if (video.currentTime >= fim || video.currentTime < inicio - 0.2) {
        video.currentTime = inicio;
      }
    }
    video.addEventListener('timeupdate', voltar);
    video.addEventListener('loadedmetadata', function () { video.currentTime = inicio; });
    if (video.readyState >= 1) video.currentTime = inicio;
  }

  /* -------------------------------------------------------- barra fixa   */

  function ligarBarra() {
    if (!barra) return;

    var hero = document.querySelector('.lp-hero');
    var rodape = document.querySelector('.footer');
    // Enquanto um botão de compra de verdade estiver na tela, a barra some:
    // duas chamadas para a mesma ação ao mesmo tempo só atrapalham.
    var botoes = document.querySelectorAll('.lp-buy, .lp-close__cta .btn');
    var naTela = [];

    barra.hidden = false;

    function avaliar() {
      var passouDaDobra = hero
        ? hero.getBoundingClientRect().bottom < 0
        : window.scrollY > 360;
      var noRodape = rodape
        ? rodape.getBoundingClientRect().top < window.innerHeight - 40
        : false;
      barra.classList.toggle('is-visible', passouDaDobra && naTela.length === 0 && !noRodape);
    }

    if (botoes.length && 'IntersectionObserver' in window) {
      var observador = new IntersectionObserver(
        function (entradas) {
          for (var i = 0; i < entradas.length; i++) {
            var alvo = entradas[i].target;
            var onde = naTela.indexOf(alvo);
            if (entradas[i].isIntersecting) {
              if (onde === -1) naTela.push(alvo);
            } else if (onde !== -1) {
              naTela.splice(onde, 1);
            }
          }
          avaliar();
        },
        { rootMargin: '-40px 0px -120px 0px' }
      );
      for (var i = 0; i < botoes.length; i++) observador.observe(botoes[i]);
    }

    avaliar();
    window.addEventListener('scroll', avaliar, { passive: true });
    window.addEventListener('resize', avaliar, { passive: true });
  }

  /* ---------------------------------------------------------- arranque   */

  function iniciar() {
    if (oferta) {
      var inicial =
        oferta.querySelector('[data-routine-card].active') ||
        oferta.querySelector('[data-routine-card]:not(.lp-kit--out)');
      if (inicial) aplicar(inicial);
    }
    ligarBarra();
    recortarVideo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
